import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import { getUrlWithOrderId, joinUrl, omitUndefinedValues } from '../utils.js'
import { ENABLED_ASSETS, PAYMENT_METHOD_NAMES } from './constants.js'
import onramperAdapter from './adapter.js'

export const getWidgetUrl = async (
  {
    apiKey,
    assets: assets_ = ENABLED_ASSETS,
    fromAmount,
    fromAsset,
    finalUrl,
    orderId,
    origin,
    paymentMethod = PAYMENT_METHOD_NAMES.debitcard,
    provider,
    preventTxnClose = true,
    skipTransactionScreen = true,
    toAsset: toAsset_ = [],
    type = ORDER_TYPES.buy,
    url = 'https://buy.onramper.com',
    walletAddress,
  } = Object.create(null)
) => {
  if (!apiKey) {
    throw new Error('`apiKey` is required')
  }

  if (fromAmount && !fromAsset) {
    throw new Error('`fromAsset` is required when `fromAmount` is provided')
  }

  const isBuy = type === ORDER_TYPES.buy
  const toAsset = Array.isArray(toAsset_) ? toAsset_[0] : toAsset_
  const cryptoAsset = isBuy ? toAsset : fromAsset
  const fiatAsset = isBuy ? fromAsset : toAsset
  const providerCryptoAsset = onramperAdapter.fromExodusToProviderAsset(cryptoAsset, assets_)

  if (!providerCryptoAsset) {
    throw new Error(`Unknown asset \`${cryptoAsset}\``)
  }

  const providerCryptoNetwork = providerCryptoAsset.split('_')[1]
  const wallets = walletAddress ? `${providerCryptoAsset}:${walletAddress}` : undefined
  const redirectUrl = getUrlWithOrderId(
    orderId,
    finalUrl,
    omitUndefinedValues({ provider: PROVIDERS.onramper, origin })
  )

  const parameters = omitUndefinedValues({
    apiKey,
    failureRedirectUrl: redirectUrl,
    mode: type,
    onlyCryptos: providerCryptoAsset,
    onlyCryptoNetworks: providerCryptoNetwork,
    onlyFiats: fiatAsset,
    partnerContext: orderId,
    successRedirectUrl: redirectUrl,
    wallets,
    ...(skipTransactionScreen
      ? {
          preventTxnClose,
          skipTransactionScreen,
          txnAmount: fromAmount,
          txnCrypto: providerCryptoAsset,
          txnFiat: fiatAsset,
          txnOnramp: provider,
          txnPaymentMethod: paymentMethod,
          txnRedirect: true,
        }
      : {
          defaultAmount: fromAmount,
          defaultCrypto: providerCryptoAsset,
          defaultFiat: fiatAsset,
          defaultPaymentMethod: paymentMethod,
        }),
  })

  return joinUrl(url, `?${new URLSearchParams(parameters)}`)
}
